import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiPartnerConsolesCompaniesAnalyticsDocumentFileCategoriesIndexResponseType,
  ApiPartnerConsolesCompaniesAnalyticsDocumentFileCategoriesIndexRequestType,
} from "~/domains";

type RequestDataType = {
  companyId: string;
  params?: ApiPartnerConsolesCompaniesAnalyticsDocumentFileCategoriesIndexRequestType;
};

const request = async ({
  params,
  companyId,
}: RequestDataType): Promise<ApiPartnerConsolesCompaniesAnalyticsDocumentFileCategoriesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiPartnerConsolesCompaniesAnalyticsDocumentFileCategoriesIndexResponseType>(
      `/api/partner_consoles/companies/${companyId}/analytics/document_file_categories`,
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiPartnerConsolesCompaniesAnalyticsDocumentFileCategoriesIndexRequestType;
  companyId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisPartnerConsolesCompaniesAnalyticsDocumentFileCategoriesIndex =
  ({
    params,
    companyId,
    config = {},
  }: PropsType): UseQueryResult<ApiPartnerConsolesCompaniesAnalyticsDocumentFileCategoriesIndexResponseType> => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
      ...config,
      queryKey: [
        "ApisPartnerConsolesCompaniesAnalyticsDocumentFileCategoriesIndex",
        companyId,
        params,
      ],
      queryFn: () => request({ companyId, params }),
    });
  };
